<script setup lang="ts">
import type { Schemas } from '@shopware/api-client/api-types/storeApiTypes';

const props = defineProps<{
    block: Schemas['CmsBlock'];
}>();

const { getSlotContent } = useCmsBlock(props.block);

const config = getSlotContent('config') as Schemas['CmsSlot'];
const image = getSlotContent('image') as Schemas['CmsSlot'];

const elementConfig = useCmsElementConfig(config);
const imagePosition = elementConfig.getConfigValue('imagePosition');
</script>

<template>
    <div
        class="mt-8 grid gap-4 md:mt-3.5 md:items-center md:gap-12"
        :class="{
            'md:grid-cols-3/2': imagePosition === 'left',
            'md:grid-cols-2/3': imagePosition === 'right',
        }"
    >
        <CmsLoader
            :content="config"
            :class="{
                'order-1': imagePosition === 'left',
                'order-1 md:order-[unset]': imagePosition === 'right',
            }"
        />
        <CmsElementImage
            :element="image"
            :shadow-position="imagePosition"
            class="!min-h-[unset]"
        />
    </div>
</template>
